//@ts-check
import { useState } from "react";
import { API } from "../../../ApiServices/apis";
import { checkSuccessStatus } from "../../../ApiServices/handleErrors";
import api from "../../../composables/app";

export const useSuggestionsHook = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSuggestions = async (description) => {
    setLoading(true);
    const data = {
      description,
    };
    try {
      const response = await api.post(`${API.character.suggestions}`, data);
      if (checkSuccessStatus(response)) {
        setSuggestions(response.data.data.suggestions);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return {
    suggestions,
    loading,
    fetchSuggestions,
  };
};
